import { Link } from 'react-router-dom';
import { Library } from 'lucide-react';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface LibrarySheetProps {
  children?: React.ReactNode;
}

export function LibrarySheet({ children }: LibrarySheetProps) {
  const { user } = useCurrentUser();

  if (!user) return null;

  return (
    <Link to="/library">
      {children || (
        <button className="p-2 rounded-full hover:bg-white/10 transition-all duration-200">
          <Library className="h-5 w-5" />
        </button>
      )}
    </Link>
  );
}
